import { gql } from '@apollo/client';
import type { SharedDocument } from 'types/Document';
import { DOCUMENT_FRAGMENT } from './DocumentFragments';

export const ADD_DOCUMENT_MUTATION = gql`
  mutation AddDocumentMutation($addDocumentInput: AddDocumentInput!) {
    addDocument(addDocumentInput: $addDocumentInput) {
      errorReason
      document {
        ...documentFields
      }
    }
  }
  ${DOCUMENT_FRAGMENT}
`;

export enum AddDocumentError {
  DUPLICATE_FILENAME = 'DUPLICATE_FILENAME',
  NOT_A_FOLDER = 'NOT_A_FOLDER',
  NOT_LINKED = 'NOT_LINKED',
  TEMP_BLOB_NOT_FOUND = 'TEMP_BLOB_NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN_DOCUMENT = 'UNKNOWN_DOCUMENT',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  WRONG_LINK = 'WRONG_LINK',
}

export type AddDocumentOutput = {
  addDocument: {
    errorReason: AddDocumentError;
    document: SharedDocument;
  };
};

export const DELETE_DOCUMENT_MUTATION = gql`
  mutation DeleteDocumentMutation($deleteDocumentInput: DeleteDocumentInput!) {
    deleteDocument(deleteDocumentInput: $deleteDocumentInput) {
      errorReason
      isDeleted
    }
  }
`;

export enum DeleteDocumentError {
  NOT_A_FOLDER = 'NOT_A_FOLDER',
  NOT_LINKED = 'NOT_LINKED',
  NOT_PARENT_FOLDER = 'NOT_PARENT_FOLDER',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN_DOCUMENT = 'UNKNOWN_DOCUMENT',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  WRONG_LINK = 'WRONG_LINK',
}

export type DeleteDocumentOutput = {
  deleteDocument: {
    errorReason: DeleteDocumentError;
    isDeleted: boolean;
  };
};